<!-- 待 -->
<template>
  <div class=''>
    <el-table
    :data="tableData"
    border
      height="680"
    style="width: 100%;margin-top: 10px">
    <el-table-column
      label="序号"
      type="index"
      width="50">
    </el-table-column>
    <el-table-column
      prop="projectName"
      show-overflow-tooltip
       align="center"
      label="项目名称"
    >
    <template slot-scope="{row}">
    {{ row.projectName}}
  </template>
    </el-table-column>
    <el-table-column
        align="center"
        show-overflow-tooltip
      label="申请仪器"
     width="350"
     >
     <template slot-scope="{row}">
          <span>仪器名称:{{ row.applyIns.instrumentName }},仪器编号:{{ row.applyIns.serialNumber }}；</span>
     </template>
    </el-table-column>
    <el-table-column
      prop="createBy"
        align="center"
      label="提交人">
    </el-table-column>
    <el-table-column
      prop="createTime"
        align="center"
        sortable
      label="提交时间">
    </el-table-column>
    <el-table-column
      prop="result"
        align="center"
      label="状态">
      <template slot-scope="{row}">
        <span :style="{color:row.result==1?'green':'red'}"> {{ row.result==1?'已通过':'已驳回' }}</span>
      </template>
    </el-table-column>
    <el-table-column
        align="center"
         width="80"
      label="操作">
      <template slot-scope="{row}">
        <el-button @click="handleClick(row)" type="text" size="small">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
   <!-- 详情 -->
   <el-dialog
  title="审批处理"
  :visible.sync="centerDialogVisible"
  width="50%"
  center>
  <detail :rowData="rowData" @cancel="centerDialogVisible =false"  :type="'view'"></detail>
</el-dialog>
  </div>
</template>

<script>
  import detail from "./detail";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {detail},
  props:{
    tableData:{
       type:Array,
       default:[]

    }
  },
    data() {
    //这里存放数据
      return {
        rowData:null,
        centerDialogVisible:false
      };
    },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleClick(row){

this.rowData = row
this.centerDialogVisible = true

},
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
ul{
  max-width: 350px;
  width: 340px;
  display: flex;
  align-items: center;
  li{
    list-style: none;
  }
}
  //@import url(); 引入公共css类

</style>


// WEBPACK FOOTER //
// src/views/approvalManagement/components/already.vue